export function IconButtonBackArrow(props) {
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.46777 5.10022L17.2021 5.10022C17.4098 5.10022 17.5815 5.1859 17.7173 5.35726C17.853 5.52862 17.9209 5.74535 17.9209 6.00743C17.9209 6.26952 17.853 6.48624 17.7173 6.6576C17.5815 6.82896 17.4098 6.91465 17.2021 6.91465L2.44381 6.91464L4.50423 9.51532C4.63201 9.6766 4.6959 9.87821 4.6959 10.1201C4.6959 10.3621 4.62402 10.5737 4.48027 10.7552C4.33652 10.9366 4.16881 11.0273 3.97715 11.0273C3.78548 11.0273 3.61777 10.9366 3.47402 10.7552L0.215687 6.64248C0.135827 6.54168 0.079924 6.44088 0.0479798 6.34007C0.0160355 6.23927 6.14634e-05 6.12839 6.1474e-05 6.00743C6.14846e-05 5.88647 0.0160355 5.77559 0.0479798 5.67479C0.0799241 5.57398 0.135827 5.47318 0.215687 5.37238L3.47402 1.25968C3.63374 1.05808 3.80545 0.962318 3.98913 0.972398C4.17281 0.982478 4.33652 1.07824 4.48027 1.25968C4.62402 1.44112 4.6959 1.65785 4.6959 1.90985C4.6959 2.16185 4.63201 2.3685 4.50423 2.52978L2.46777 5.10022Z"
        fill="currentColor"
      />
    </svg>
  )
}
